import { linhaTabelaClicavelNovaGuia } from './../../utils/tabelaUtils'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import msgConstants from '../../constants/msgConstants'
import parceiroManager from '../../services/api/parceiro/parceiroManager'
import RegularizacaoOPsTitulosManager from '../../services/api/regularizacaoOpsTitulos/regularizacaoOPsTitulosManager'
import { loadingReset, loadingUpdate } from '../../store/actions/loadingAction'
import { Parceiro } from '../../types/parceiroApiTypes'
import { RegularizacaoPendenteForm, ResponseRegularizacaoPendente, valorPadraoRegularizacaoPendencia } from '../../types/regularizacaoOPsTitulosTypes'
import { Paginacao } from '../../types/tabelaTypes'
import { pegarParametrosQuery } from '../../utils/stringUtils'

import { regularizacaoPedidosInformacoesStyles } from './RegularizacaoPedidosInformacoes.styles'
import { PAGES } from '../../router/routes'
import { useConciliacaoContext } from '../../contexts/conciliacao-context'

export function regularizacaoPedidosInformacoesIO() {
  const { pendenciasOpsTitulos, SalvarPendenciasOpsTitulos } = useConciliacaoContext()
  const [pendenciaRegularizacao, setPendenciaRegularizacao] = useState<ResponseRegularizacaoPendente>(pendenciasOpsTitulos || valorPadraoRegularizacaoPendencia)
  const [parceirosAtivos, setParceirosAtivos] = useState<Parceiro[]>([])
  const [formularioPreenchido, setFormularioPreenchido] = useState<boolean>(true)
  const [pesquisaRealizada, setPesquisaRealizada] = useState<boolean>(false)
  const query = pegarParametrosQuery()
  const rotas = useHistory()
  const dispatch = useDispatch()
  const parceiroIdQuery = query.get('parceiroId')
  const pedidoPlanilhaIdQuery = query.get('pedidoPlanilhaId')
  const clienteIdQuery = query.get('clienteId')
  const ordemPagamentoIdQuery = query.get('ordemPagamentoId')

  useEffect(() => {
    async function fetchData() {
      const response: Parceiro[] = await parceiroManager.buscarDadosParceiros(true)
      setParceirosAtivos(response)
      dispatch(loadingReset())
    }

    dispatch(loadingUpdate(true))
    fetchData()
  }, [dispatch])

  const { handleSubmit, control, setValue, watch } = useForm<RegularizacaoPendenteForm>({
    defaultValues: {
      pedidoPlanilhaId: '',
      clienteId: '',
      parceiroId: '',
      ordemPagamentoId: ''
    }
  })

  const pedidoHabilitado = watch('pedidoPlanilhaId')
  const clienteHabilitado = watch('clienteId')
  const parceiroHabilitado = watch('parceiroId')
  const ordemPagamentoHabilitado = watch('ordemPagamentoId')

  useEffect(() => {
    if (pedidoHabilitado || clienteHabilitado || parceiroHabilitado || ordemPagamentoHabilitado) {
      setFormularioPreenchido(false)
    } else {
      setFormularioPreenchido(true)
    }
  }, [pedidoHabilitado, clienteHabilitado, parceiroHabilitado, ordemPagamentoHabilitado])

  const limparFormularioPesquisa = () => {
    rotas.push(PAGES.regularizacaoPedidosInformacaoId(null, null, null, null))
    setValue('clienteId', '')
    setValue('parceiroId', '')
    setValue('pedidoPlanilhaId', '')
    setValue('ordemPagamentoId', '')
    setPendenciaRegularizacao(valorPadraoRegularizacaoPendencia)
  }

  useEffect(() => {
    if (parceiroIdQuery && parceiroIdQuery !== '0') {
      setValue('parceiroId', parceiroIdQuery)
    }
    if (pedidoPlanilhaIdQuery) {
      setValue('pedidoPlanilhaId', pedidoPlanilhaIdQuery)
    }
    if (clienteIdQuery && clienteIdQuery !== '0') {
      setValue('clienteId', clienteIdQuery)
    }
    if (ordemPagamentoIdQuery) {
      setValue('ordemPagamentoId', ordemPagamentoIdQuery)
    }
  }, [parceiroIdQuery, pedidoPlanilhaIdQuery, clienteIdQuery, ordemPagamentoIdQuery, setValue])

  // cicloId é omitido de propósito: o /Pendencias trata a ausência de ciclo como "sem filtro de ciclo" (research.md §1)
  async function aplicarFiltro(paginacao: Paginacao) {
    dispatch(loadingUpdate(true))

    RegularizacaoOPsTitulosManager.buscarRegularizacoesPendentes({
      pedidoPlanilhaId: pedidoHabilitado,
      clienteId: clienteHabilitado,
      parceiroId: parceiroHabilitado,
      ordemPagamentoId: ordemPagamentoHabilitado,
      incluirPedidosSemOp: true,
      pageNumber: paginacao.pageNumber,
      pageSize: paginacao.pageSize,
      orderBy: paginacao.orderBy,
      orderField: paginacao.orderField
    })
      .then((response: ResponseRegularizacaoPendente) => {
        setPendenciaRegularizacao(response)
        SalvarPendenciasOpsTitulos(response)
      })
      .catch(() => {
        toast.error(msgConstants.REGULARIZACAO.erroAoBuscarPendencias)
      })
      .finally(() => {
        setPesquisaRealizada(true)
        dispatch(loadingReset())
      })
  }

  const buscarValorPesquisado = (filtro?: RegularizacaoPendenteForm) => {
    aplicarFiltro({ pageNumber: 1, pageSize: 25 })
    rotas.push(PAGES.regularizacaoPedidosInformacaoId(filtro?.parceiroId, filtro?.pedidoPlanilhaId, filtro?.clienteId, filtro?.ordemPagamentoId))
  }

  const handleDirecionarRegularizacao = (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, pedidoId: string) => {
    const clienteId = clienteHabilitado ? clienteHabilitado : '0'

    linhaTabelaClicavelNovaGuia(event, PAGES.regularizacaoPedidosEfetivacaoId(pedidoId, clienteId), rotas)
  }

  return {
    styles: regularizacaoPedidosInformacoesStyles,
    control,
    pendenciaRegularizacao,
    limparFormularioPesquisa,
    handleSubmit,
    aplicarFiltro,
    parceirosAtivos,
    buscarValorPesquisado,
    formularioPreenchido,
    pesquisaRealizada,
    handleDirecionarRegularizacao
  }
}

export type RegularizacaoPedidosInformacoesIO = ReturnType<typeof regularizacaoPedidosInformacoesIO>
